import { Card, Row, Statistic } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export const SettingsCard = styled(Card)`
  background-color: ${APP_SHELL_THEME.panelBg};
  border-color: ${APP_SHELL_THEME.panelBorder};
  border-radius: 8px;
  margin-bottom: 24px;

  .ant-card-head {
    padding: 16px 24px;
    border-bottom: 1px solid ${APP_SHELL_THEME.panelBorder};
  }

  .ant-card-head-title {
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
  }

  .ant-card-head-wrapper {
    display: flex;
    align-items: center;
  }

  .ant-card-body {
    padding: 24px;
    text-align: center;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
  }
`;

export const KPIRow = styled(Row)`
  margin-bottom: 24px;
`;

export const KPICard = styled(Card).attrs({ className: 'metric-card' })`
  height: 100%;
  background-color: ${APP_SHELL_THEME.metricCardBg} !important;
  border: 1px solid ${APP_SHELL_THEME.metricCardBorder} !important;
  border-radius: 6px;
  box-shadow: none;

  .ant-card-body {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: transparent !important;
  }
`;

export const StyledStatistic = styled(Statistic)`
  .ant-statistic-title {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.52);
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 8px;
  }

  .ant-statistic-content {
    .ant-statistic-content-value {
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
      font-size: 20px;
      font-weight: 600;
    }
  }
`;

export const TableCard = styled(Card)`
  background-color: ${APP_SHELL_THEME.panelBg};
  border-color: ${APP_SHELL_THEME.panelBorder};
  border-radius: 8px;

  .ant-card-body {
    padding: 24px;
  }

  .ant-table-wrapper {
    .ant-table-thead > tr > th {
      background-color: rgba(97, 97, 215, 0.18) !important;
      color: ${APP_SHELL_THEME.tableHeader} !important;
      font-weight: 600;
    }

    .ant-table-tbody > tr > td {
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;
    }

    .ant-table-tbody > tr:hover > td:not(.ant-table-cell-fix-right):not(.ant-table-cell-fix-left) {
      background-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.04) !important;
    }

    .ant-table-cell {
      &.numeric {
        text-align: right;
      }
    }

    .actions {
      min-width: 260px !important;
      width: 260px !important;
      white-space: nowrap;
    }

    .ant-table-thead > tr > th.actions {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ant-table-thead > tr > th.actions.ant-table-cell-fix-right {
      background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
      z-index: 4 !important;
    }

    .ant-table-tbody > tr > td.actions.ant-table-cell-fix-right {
      background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
      z-index: 2 !important;
    }

    .ant-table-tbody > tr:hover > td.actions.ant-table-cell-fix-right {
      background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
    }

    .ant-table-thead > tr > th.actions.ant-table-cell-fix-right-first::after {
      box-shadow: none !important;
      background: ${APP_SHELL_THEME.tableFixedHeaderBg} !important;
    }

    .ant-table-tbody > tr > td.actions.ant-table-cell-fix-right-first::after {
      box-shadow: none !important;
      background: ${APP_SHELL_THEME.tableFixedBodyBg} !important;
    }

    .ant-table-tbody > tr:hover > td.actions.ant-table-cell-fix-right-first::after {
      background: ${APP_SHELL_THEME.tableFixedBodyHoverBg} !important;
    }

    .ant-table-summary .rates-table-total-row > .ant-table-cell {
      background-color: ${APP_SHELL_THEME.panelBg} !important;
      border-top: 2px solid ${APP_SHELL_THEME.panelBorder};
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
    }

    .ant-table-summary .rates-table-total-row > .ant-table-cell.ant-table-cell-fix-right {
      background: ${APP_SHELL_THEME.panelBg} !important;
      z-index: 2 !important;
    }

    .ant-btn-text:not(.ant-btn-dangerous) {
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88) !important;
    }

    .ant-btn-text:not(.ant-btn-dangerous) .anticon {
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88) !important;
    }

    .ant-btn-text:not(.ant-btn-dangerous):hover {
      background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.08) !important;
      color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.95) !important;
    }
  }
`;

export const SectionHeading = styled.h2`
  margin: 16px 0 12px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
`;

export const ActionBar = styled(Row)`
  margin-bottom: 16px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;

  .empty-icon {
    font-size: 64px;
    color: ${APP_SHELL_THEME.textMuted};
    margin-bottom: 16px;
  }

  .empty-title {
    font-size: 18px;
    font-weight: 600;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
    margin-bottom: 8px;
  }

  .empty-description {
    font-size: 14px;
    color: ${APP_SHELL_THEME.textMuted};
    margin-bottom: 24px;
    max-width: 400px;
  }
`;

export const FormRow = styled(Row)`
  margin-bottom: 16px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88);
  margin-bottom: 8px;
`;

export const HelperText = styled.span`
  font-size: 12px;
  color: ${APP_SHELL_THEME.textMuted};
  margin-top: 4px;
  display: block;
`;
